// extracted by mini-css-extract-plugin
export default {"form":"styles_form__dhNj1","diasbledText":"styles_diasbledText__XsbR4"};